import styled from 'styled-components';
import { Button } from '../design-system';

const CancelButton = styled(Button)`
  color: ${(p) => p.theme.colors.error};
`;

export default CancelButton;
